import { ptBR } from "date-fns/locale";

export const MAX_AUTO_LOGINS_ATTEMPTS = 4;

export const APP_IS_RUNNING_IN_DEV = process.env.NODE_ENV === "development";

export const EMPTY_STRING_LABEL = "-";

export const DEFAULT_LOCALE = ptBR;

export const GLOBAL_REFRESH_TIMER = 30 * 60 * 1000;

export const APP_DEFAULT_NUMBER_OF_NOTIFICATIONS = 10;

export const DEFAULT_MAX_ITEM_PER_PAGE = 10;

export const FALLBACK_API_URL = "http://bradanaspdig01:8095/api";